import { Box, Typography } from '@telus-uds/components-web';
import ReactMarkdown from 'react-markdown';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { mdCompsMapping } from '../../utils/md-components';
import './MainLayout.css';

const MainLayout = ({ children, title }) => (
  <div className="mainLayoutContainer">
    <Header />
    <div className="mainLayout">
      <Box horizontal={3} top={5}>
        <Typography align="left">
          <ReactMarkdown components={mdCompsMapping}>{title}</ReactMarkdown>
        </Typography>
        {children}
      </Box>
    </div>
    <Footer />
  </div>
);

export default MainLayout;
